/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseMaintenanceEventApiData } from './genericApiResponseMaintenanceEventApiData';
import type { GenericApiResponseMaintenanceEventApiMessage } from './genericApiResponseMaintenanceEventApiMessage';
import type { GenericApiResponseMaintenanceEventApiPagination } from './genericApiResponseMaintenanceEventApiPagination';
import type { GenericApiResponseMaintenanceEventApiError } from './genericApiResponseMaintenanceEventApiError';

export interface GenericApiResponseMaintenanceEventApi {
  data?: GenericApiResponseMaintenanceEventApiData;
  message?: GenericApiResponseMaintenanceEventApiMessage;
  pagination?: GenericApiResponseMaintenanceEventApiPagination;
  error?: GenericApiResponseMaintenanceEventApiError;
  statusCode?: number;
}
